module.exports = __webpack_public_path__ + "static/imgs/circle-outer3.afaeced.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/circle/circle-outer3.png
// module id = CTKI
// module chunks = 1